import React, { useState } from "react";
import axios from "axios";
import { toastSuccess, toastError } from "../../../shared/toastHelper";
import PaymentMethods from "./PaymentMethods";

const SubscriptionSetup = ({
  teamId,
  csrfToken,
  subscriptionType = "sms",
  subscriptionInfo,
  createEndpoint,
  onSuccess,
  buttonLabel = "Enable",
}) => {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedPaymentMethodId, setSelectedPaymentMethodId] = useState(null);
  const [enabling, setEnabling] = useState(false);

  const handlePaymentMethodsChange = (methods, defaultId) => {
    setPaymentMethods(methods);
    if (methods.length > 0 && !selectedPaymentMethodId) {
      setSelectedPaymentMethodId(defaultId || methods[0].id);
    }
  };

  const handlePaymentMethodAdded = (paymentMethodId) => {
    if (paymentMethods.length === 0) {
      setTimeout(() => {
        handleEnableSubscription(paymentMethodId);
      }, 500);
    }
  };

  const handleEnableSubscription = async (paymentMethodIdOverride) => {
    const pmId = paymentMethodIdOverride || selectedPaymentMethodId;
    if (!pmId) {
      toastError("Please select a payment method");
      return;
    }

    setEnabling(true);
    try {
      axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;

      await axios.post(`/teams/${teamId}/payment_methods/${pmId}/set_default`);

      const endpoint = createEndpoint || `/teams/${teamId}/${subscriptionType}_subscription`;
      await axios.post(endpoint);

      toastSuccess(`${buttonLabel} successful!`);
      if (onSuccess) {
        onSuccess();
      } else {
        window.location.reload();
      }
    } catch (error) {
      const message = error.response?.data?.error || `Failed to enable ${subscriptionType}`;
      toastError(message);
    } finally {
      setEnabling(false);
    }
  };

  const hasPaymentMethods = paymentMethods.length > 0;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      {subscriptionInfo && (
        <div style={{ marginBottom: 4 }}>
          {subscriptionInfo}
        </div>
      )}

      <PaymentMethods
        teamId={teamId}
        csrfToken={csrfToken}
        onSuccess={handlePaymentMethodAdded}
        onPaymentMethodsChange={handlePaymentMethodsChange}
        mode="select"
        selectedPaymentMethodId={selectedPaymentMethodId}
        onSelectionChange={setSelectedPaymentMethodId}
        showHeader={false}
        showEmptyState={false}
        addButtonLabel="Add Payment Method"
        addAnotherLabel="+ Add another card"
      />

      {hasPaymentMethods && (
        <button
          onClick={() => handleEnableSubscription()}
          disabled={enabling || !selectedPaymentMethodId}
          style={{
            padding: "12px 24px",
            borderRadius: 8,
            border: "none",
            backgroundColor: enabling || !selectedPaymentMethodId ? "#9CA3AF" : "#1982C4",
            color: "white",
            cursor: enabling || !selectedPaymentMethodId ? "not-allowed" : "pointer",
            fontSize: 14,
            fontWeight: 500,
            width: "fit-content",
          }}
        >
          {enabling ? "Enabling..." : buttonLabel}
        </button>
      )}
    </div>
  );
};

export default SubscriptionSetup;
